import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { alpha, IconButton, IconButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

type ToggleIconProps = Pick<IconButtonProps, 'onClick'> & {
  isExpanded: boolean;
  labelInfo?: string;
};

const ToggleIcon: FC<ToggleIconProps> = (props) => {
  const { isExpanded, labelInfo, ...rest } = props;
  const labelTextPrefix = isExpanded ? 'Show less' : 'Show more';
  const labelText = labelInfo ? `${labelTextPrefix} ${labelInfo}` : labelTextPrefix;
  return (
    <ToggleIconButton
      size="large"
      disableRipple={false}
      disableFocusRipple={false}
      sx={{ transform: !isExpanded ? 'rotate(0deg)' : 'rotate(180deg)' }}
      aria-expanded={isExpanded}
      aria-label={labelText}
      {...rest}
    >
      <ExpandMoreIcon />
    </ToggleIconButton>
  );
};

const ToggleIconButton = styled(IconButton)(({ theme }) => {
  const smallButtonSize = 4.5;
  const largeButtonSize = 6;
  return {
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: alpha(theme.palette.black.main, 0.04),
    },
    '&:focus': {
      backgroundColor: alpha(theme.palette.black.main, 0.04),
    },
    '&.MuiIconButton-sizeSmall': {
      width: theme.spacing(smallButtonSize),
      height: theme.spacing(smallButtonSize),
    },
    '&.MuiIconButton-sizeSmall .MuiSvgIcon-root': {
      width: theme.spacing(smallButtonSize / 2),
      height: theme.spacing(smallButtonSize / 2),
    },
    '&.MuiIconButton-sizeLarge': {
      width: theme.spacing(largeButtonSize),
      height: theme.spacing(largeButtonSize),
    },
    '&.MuiIconButton-sizeLarge .MuiSvgIcon-root': {
      width: theme.spacing(largeButtonSize / 2),
      height: theme.spacing(largeButtonSize / 2),
    },
  };
});

export { ToggleIcon as default, ToggleIcon };
export type { ToggleIconProps };
